import { Option } from "../components/common/forms/Interfaces";
import { OptionMap } from "../helpers/optionMap";

export const EUR = "eur" as const;
export const USD = "usd" as const;
export const PLN = "pln" as const;
export const BYN = "byn" as const;
export const RUB = "rub" as const;

export type CurrencyType =
  | typeof EUR
  | typeof USD
  | typeof PLN
  | typeof BYN
  | typeof RUB;

export type DepartmentDataCurrencies = typeof EUR | typeof USD | typeof PLN;

const currencyTypes = {
  eur: "EUR",
  usd: "USD",
  pln: "PLN",
  byn: "BYN",
  rub: "RUB",
} as const;
export type CurrencyTypeUppercase = typeof currencyTypes[keyof typeof currencyTypes];
export const currencyMap = new OptionMap<CurrencyType>(currencyTypes);

const CURRENCY: Option[] = currencyMap.getOptions();

export default CURRENCY;
